import makeRequest from './index';

export function fetchLeaderShip() {
    return makeRequest({
        uri: '/v1/leaderships',
        method: 'GET'
    });
}
